import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import RouterContainer from 'routers/RouterContainer';
import { ThemeProvider } from 'styled-components';
import store from './store';
import './styles/global.scss';
import { Config } from './utils/config/config';
import theme from './styles/variables.scss';
import { FeatureFlagProvider } from './components/library/FeatureFlag/context';

const App = () => {
  const [configLoaded, setConfigLoaded] = useState(false);

  const getConfig = async () => {
    await Config.loadConfig();
    setConfigLoaded(true);
  };

  useEffect(() => {
    getConfig();
  }, []);

  return (
    <>
      {configLoaded && (
        <Provider store={store}>
          <FeatureFlagProvider>
            <ThemeProvider theme={theme}>
              <BrowserRouter>
                <Route
                  render={(props: any) => <RouterContainer {...props} />}
                />
              </BrowserRouter>
            </ThemeProvider>
          </FeatureFlagProvider>
        </Provider>
      )}
    </>
  );
};

export default App;
